export default "__VITE_ASSET__DSEY5cNN__"